<template>
  <div class="couponContainer">
    <div class="couponItem">
      <div class="iconPart">
        <!-- 满减券 -->
        <div
          class="couponHead"
          v-if="
            couponType === 'DISCOUNT_NO_CONDITION' ||
              couponType === 'DISCOUNT_WITH_CONDITION'
          "
        >
          <div class="value">
            <span class="unit">&yen;</span
            ><span class="integerPart">{{
              Math.floor(data.discountAmount / 100)
            }}</span
            ><span class="floatPart">{{
              data.discountAmount % 100 !== 0
                ? `.${data.discountAmount % 100}`
                : ''
            }}</span>
          </div>
          <div class="condition">{{ couponDescText(data) }}</div>
        </div>
        <!-- 折扣券 -->
        <div class="couponHead" v-if="couponType === 'DISCOUNT_BY_RATE'">
          <div class="value">
            <span class="integerPart">{{
              Math.floor(data.discountRate / 10)
            }}</span
            ><span class="floatPart"
              >.{{
                data.discountRate % 10 !== 0 ? data.discountRate % 10 : 0
              }}</span
            ><span class="suffix">折</span>
          </div>
          <div class="condition">{{ couponDescText(data) }}</div>
        </div>
      </div>
      <div class="contentPart">
        <div class="titleRow">
          <span class="tag">{{ data.businessTypeStr }}</span>
          <span class="title">{{ data.title }}</span>
        </div>
        <div class="time">{{ timeRange }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';
import { toDayDate } from '../../helper';
// 折扣类型，1-立减券;2-折扣券 3-满减券
const COUPON_DICOUNT_TYPE = {
  1: 'DISCOUNT_NO_CONDITION',
  2: 'DISCOUNT_BY_RATE',
  3: 'DISCOUNT_WITH_CONDITION'
};

export default {
  props: {
    data: {
      type: Object,
      require: true
    },
    isShowToUseBtn: {
      type: Boolean,
      default: false
    },
    isShowRuleBtn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShowRulePanel: false
    };
  },
  computed: {
    couponType() {
      if (this.data.discountType === 1 && this.data.reachFen) {
        return COUPON_DICOUNT_TYPE[3];
      }
      return COUPON_DICOUNT_TYPE[this.data.discountType];
    },
    timeRange() {
      if (this.data.dateType === 'absolute') {
        const startTime = this.data.startTime
          ? toDayDate(this.data.startTime)
          : '';
        const endTime = this.data.endTime ? toDayDate(this.data.endTime) : '';
        return `${startTime}-${endTime}`;
      } else if (this.data.dateType === 'relative') {
        return `自领取当日起 ${this.data.effectiveDay} 天有效`;
      } else {
        return '';
      }
    }
  },
  methods: {
    couponDescText(data) {
      const type = this.couponType;
      switch (type) {
        case 'DISCOUNT_NO_CONDITION':
          return '下单立减';
        case 'DISCOUNT_BY_RATE':
          return `最高减${data.discountAmount / 100}元`;
        case 'DISCOUNT_WITH_CONDITION':
          return `满${data.reachFen / 100}元可用`;
        default:
          return '';
      }
    },
    handleClickRuleBtn() {
      this.isShowRulePanel = !this.isShowRulePanel;
      if (this.isShowRulePanel && !this.direction) {
        this.$emit('getCouponDetail', this.data.rewardCode);
      }
      this.reportClickRule(this.isShowRulePanel);
    },
    handleUse() {
      this.reportUseBtnClick();
      useCoupon(this.data.businessType);
    },
    reportUseBtnClick() {
      this.$emit('reportEvent', {
        event: 'column_reward_click',
        module_name: '去使用',
        coupon_business_line: this.data.businessTypeStr
      });
    },
    reportClickRule(isShowRulePanel) {
      if (isShowRulePanel) {
        this.$emit('reportEvent', {
          event: 'column_reward_click',
          module_name: '使用规则',
          coupon_business_line: this.data.businessTypeStr
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.couponContainer {
  margin-bottom: 16px;
  box-sizing: border-box;
  background: center / cover url('../assets/images/coupon-bg.png') no-repeat;

  &:last-child {
    margin-bottom: 0px;
  }
}
.couponItem {
  border-radius: 10px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.09);
  padding: 25px 5px;
  display: flex;
  justify-content: space-between;

  .iconPart {
    flex: 0 0 150px;
    .couponHead {
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 1.1;
      .value {
        color: #ff2727;
        font-family: 'Alibaba Zhixing';
        margin-bottom: 10px;

        .integerPart {
          font-size: 50px;
        }

        .floatPart {
          font-size: 50px;
        }

        .unit {
          font-size: 24px;
        }
      }
      .condition {
        font-size: 24px;
        color: #595959;
      }
    }
  }

  .contentPart {
    flex: 1;
    padding-left: 16px;
    position: relative;

    .titleRow {
      display: flex;
      align-items: center;
      .tag {
        font-size: 22px;
        color: #e43d23;
        border: 1px solid #e43d23;
        border-radius: 5px;
        padding: 0px 4px;
        margin-right: 10px;
      }

      .title {
        color: #333333;
        font-weight: bolder;
        font-size: 26px;
        max-width: 240px;
        white-space: nowrap;
        overflow: hidden;
      }
    }

    .time {
      color: #595959;
      font-size: 24px;
      margin-top: 20px;
    }
  }
}
</style>
